import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// TeacherRoute component - allows all authenticated users to view, but only teachers to edit
const TeacherRoute = ({ component: Component, authenticated, user, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // Om användaren inte är inloggad, omdirigera till login
      if (!authenticated) {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        );
      }

      // Skicka med canEdit prop baserat på om användaren är lärare eller admin
      const activeUser = user || JSON.parse(localStorage.getItem('userProfile') || 'null');
      const canEdit = activeUser && (activeUser.role === 'teacher' || activeUser.role === 'admin');
      
      // Alla inloggade användare får se innehållet
      return <Component {...props} canEdit={canEdit} user={activeUser} />;
    }}
  />
);

TeacherRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  location: PropTypes.object
};

const mapStateToProps = (state) => ({
  authenticated: state.authentication.authenticated,
  user: state.authentication.profile
});

export default connect(mapStateToProps)(TeacherRoute); 